<template>
	<div class="index_zzsh">
		<!-- banner图 -->
		<div class="newsCenterBanenr">
			<a :href="`http://xndj.gxsentu.net/djspecial/#/djxc?uid=${getdata.user_id}&uflag=${getdata.flag}`"
				target="_blank">
				<img src="../../assets/xiangning/zzsh/zzsh_banne_xn.png"></a>
		</div>
		<div class="home_wrap">
			<!-- 上方标题栏 -->
			<div class="news_title">
				<div class="title_left">
					<img src="../../assets/xiangning/home/titile_left.png" alt="">
				</div>
				<div class="news_title_left">
					<div class="news_title_left_text" @click="changeselectNum(1)"
						:style="{ color: selectNum == 1 ? '#D31813' : '#999999', fontWeight: selectNum == 1 ? '800' : '400' }">三会一课</div>
				</div>
				<div class="right_back">
					<div class="right_back_icon"></div>
					<div></div>
				</div>
			</div>

			<!-- 视频列表 -->
			<div class="dataList">
				<!-- 遍历列表循环 -->
				<div class="dataList_item" @click="goZzshDetail(item)" v-for="item in dataList">
					<!-- 课程状态未开始-->
					<div class="notStart" v-if="false">
						未开始
					</div>
					<!-- 课程状态已完成-->
					<div class="haveFilsh" v-if="false">
						已完成
					</div>
					<div class="dataList_item_top_img">
						<img v-if="item.img != ''" :src="item.img" alt="">
						<img v-else src="../../assets/xiangning/userCenter/dzzhd.png" alt="">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}</div>
						<!-- 所属组织 -->
						<div class="dataList_item_bottom_center">
							<span>{{ item.type }}</span>
							<span>{{ item.h_stime }}</span>
						</div>
						<!-- 地点 -->
						<div class="dataList_item_bottom_address">
							{{ item.address }}
						</div>
					</div>
				</div>
			</div>
			<!-- 下方分页器 -->
			<div class="pagination">
				<div class="block">
					<el-pagination @current-change="handleCurrentChange" :current-page="per_page" :page-sizes="[12]"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
import Swiper from 'swiper';
import { zzsh } from '@/axios';
import Title from '@/components/title.vue'
export default {
	data() {
		return {
			// 总数据条数
			total: 100,
			// 当前页码
			per_page: 1,
			index: 0,
			selectNum: 1,
			getdata: {
				user_id: this.$store.state.user.userinfo2.id,
				flag: this.$store.state.user.userinfo2.flag,
				page: 1
			},
			dataList: []
		}
	},
	components: { Title },
	methods: {
		// 切换导航
		changeselectNum(val) {
			this.selectNum = val
		},
		handleCurrentChange(val) {
			this.getdata.page = val
			this.getDataList()
		},
		getDataList() {
			let that = this
			zzsh.shykList(this.getdata).then(res => {
				if (res.code == 200) {
					that.dataList = res.data.pagedata
					that.total = res.data.count
				}
			})
		},
		// 组织生活详情
		goZzshDetail(data) {
			this.$router.push({
				path: '/zzshDetail',
				query: {
					id: data.id,
					flag: data.hyflag
				}
			})
		}
	},
	mounted() {
		let that = this
		this.getDataList()

	},
	created() {
		this.$emit("highLight", 1, "", "", "");
	}
}
</script>

<style lang="scss">
@import '@/common/index.scss';

.index_zzsh {
	width: 100%;

	.newsCenterBanenr {
		cursor: pointer;
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}

	}

	div {
		box-sizing: border-box;
	}

	.Interpretation_content {
		width: 100%;
		margin-top: 20px;

		.shizheng_right_item {
			position: relative;
			height: 67px;
			width: 100%;
			border-bottom: 1px solid #ECEEF4;
			display: flex;
			justify-content: space-between;
			overflow: hidden;

			.shizheng_right_item_left {
				height: 100%;
				width: 44px;
				padding: 10px 0;
				margin-right: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.year {
					font-family: PingFangSC-Regular;
					font-size: 18px;
					font-weight: normal;
					text-align: center;
					letter-spacing: 0px;
					color: #333333;
				}

				.mouth {
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					text-align: center;
					letter-spacing: 0px;
					color: #999999;
				}
			}

			.shizheng_right_item_right {
				height: 100%;
				width: 793px;
				padding: 10px 0 10px 20px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title_top {
					width: 710px;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					letter-spacing: 0px;
					color: #000000;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.title_top:hover {
					color: #EE632B;
					font-weight: 800;
				}

				.content_bottom {
					width: 98%;
					font-family: MicrosoftYaHei;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0px;
					color: #999999;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}

			.shizheng_right_item_center {
				position: absolute;
				width: 2px;
				height: 20px;
				opacity: 1;
				background: #EE632B;
				top: 20px;
				left: 54px;
			}

		}
	}

	.home_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;

		/* 视频列表 */
		.dataList {
			width: 100%;
			margin-top: 20px;
			display: flex;
			flex-wrap: wrap;
			justify-content: start;
			align-content: start;
			overflow: hidden;
		}

		.dataList_item {
			box-sizing: border-box;
			width: 224px;
			height: 208px;
			margin-bottom: 20px;
			margin-right: 20px;
			/* 修改圆角 */
			border-radius: 4px;
			overflow: hidden;
			position: relative;
		}

		.notStart {
			height: 24px;
			width: 62px;
			color: #fff;
			position: absolute;
			left: 0px;
			top: 10px;
			// background-image: url(../image/zzsh/notstart.png);
			background-image: url(../../assets/xiangning/zzsh/notstart.png);
			font-family: 思源黑体;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #FFFFFF;
			line-height: 24px;
			box-sizing: border-box;
			padding-left: 7px;
		}

		.haveFilsh {
			height: 24px;
			width: 62px;
			color: #fff;
			position: absolute;
			left: 0px;
			top: 10px;
			background-image: url(../../assets/xiangning/zzsh/haveFinlsh.png);
			font-family: 思源黑体;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #FFFFFF;
			line-height: 24px;
			box-sizing: border-box;
			padding-left: 7px;
		}

		.dataList_item:nth-child(5n) {
			margin-right: 0;
		}

		.dataList_item_top_img {
			height: 126px;
			width: 224px;
			/* 修改圆角 */
			border-radius: 4px 4px 0 0;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.dataList_item_bottom {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 100%;
			height: 82px;
			border: 1px solid #ECEEF4;
			padding: 5px 10px;
			/* 修改圆角 */
			border-radius: 0 0 4px 4px;
			overflow: hidden;
		}

		.dataList_item_bottom_top_title {
			width: 100%;
			height: 20px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			font-weight: 800;
			line-height: 20px;
			color: #000000;
		}

		.dataList_item_bottom_center {
			width: 100%;
			height: 17px;
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			text-align: right;
			letter-spacing: 0em;
			color: #999999;
			display: flex;
			justify-content: space-between;


		}

		.dataList_item_bottom_address {

			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #999999;
			width: 100%;
			height: 17px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

		}

		.dataList_item_bottom_center span:nth-child(1) {
			max-width: 83px;
			overflow: hidden;
			white-space: nowrap;

		}



		.dataList_item_bottom_top_title:hover {
			color: #C9010A;
		}

		.dataList_item_bottom_botom {
			height: 16px;
			width: 100%;
			display: flex;
		}

		.dataList_item_bottom_botom_item {
			overflow: hidden;
			height: 100%;
			width: 74px;
			display: flex;
			justify-content: center;
		}

		.dataList_item_bottom_botom_item:nth-child(2) {
			border-left: 1px solid #ECEEF4;
			border-right: 1px solid #ECEEF4;
			;
		}

		.dataList_item_bottom_botom_item:nth-child(1) {
			display: flex;
			justify-content: start;
		}

		.dataList_item_bottom_botom_item:nth-child(3) {
			display: flex;
			justify-content: end;
		}

		.dataList_item_bottom_botom_item_icon {
			height: 12px;
			width: 12px;
			margin-right: 2px;
			position: relative;
		}

		.dataList_item_bottom_botom_item_icon img {
			position: absolute;
			top: 2.5px;
		}

		.dataList_item_bottom_botom_item:nth-child(3) .dataList_item_bottom_botom_item_icon {
			height: 10px;
			width: 15px;
		}

		.dataList_item_bottom_botom_item_icon img {
			height: 100%;
			width: 100%;
		}

		.dataList_item_bottom_botom_item_content {
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;

			color: #999999;
		}

		/* 标题部分样式 */
		.news_title{
				
				height: 32px;
				width: 100%;
				margin:20px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding-left:32px;
				background: #FFF6F1;
				box-sizing: border-box;
				position: relative;
				.title_left{
					position: absolute;
					top: -5px;
					left: 0;
					height: 42px;
					width: 42px;
					img{
						width: 100%;
						height: 100%;
					}
				}
			}

		.news_title_left {
			// width: 300px;
			height: 22px;
			// padding-left: 20px;
			display: flex;
			justify-content: space-between;

		}

		.news_title_left_text {
			height: 22px;
			// width: 80px;
			padding: 0 5px;
			font-family: PingFangSC-Regular;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0.1em;
			color: #999999;
		}

		.right_back {
			display: flex;
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #666666;
			margin-right: 10px;
		}

		.right_back:hover {
			font-weight: 800;
			color: #EE632B;
		}

		.right_back_icon {
			height: 10px;
			width: 12px;
			margin-right: 5px;
		}

		.right_back_icon img {
			height: 100%;
			width: 100%;
		}

		/* 内容部分样式 */
		.news_content {
			// height: 754px;
			width: 100%;
			overflow: hidden;
			/* background-color: pink; */
		}

		.news_content_item {
			height: 122px;
			width: 100%;
			/* background-color: skyblue; */
			border-bottom: 1px solid #ECEEF4;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.news_content_item_left_pic {
			height: 168px;
			width: 270px;
		}

		.news_content_item_left_pic img {
			width: 100%;
			height: 100%;
		}

		.news_content_item_right {
			height: 71px;
			width: 1082px;
			/* background-color: pink; */
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}

		.news_content_item_right_toptitle {
			height: 20px;
			width: 80%;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			font-weight: 800;
			letter-spacing: 0px;

			color: #000000;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.news_content_item_right_toptitle:hover {
			color: #EE632B;
		}

		.news_content_item_right_center {
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			line-height: 20px;
			text-align: justify;
			/* 浏览器可能不支持 */
			letter-spacing: 0px;
			color: #666666;
			width: 100%;
			max-height: 82px;
			overflow: hidden;
			text-overflow: ellipsis;
			/* 将对象作为弹性伸缩盒子模型显示 */
			display: -webkit-box;
			/* 限制在一个块元素显示的文本的行数 */
			/* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
			-webkit-line-clamp: 2;
			/* 设置或检索伸缩盒对象的子元素的排列方式 */
			-webkit-box-orient: vertical;

		}

		.news_content_item_right_bottom {
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			line-height: 20px;
			text-align: justify;
			/* 浏览器可能不支持 */
			letter-spacing: 0px;
			color: #666666;
			display: flex;
			justify-content: right;
		}

		/* .分页器 */

		.pagination {
			height: 48px;
			width: 648px;
			margin: 0 auto;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #EE632B;
			margin-bottom: 30px;
		}


		.el-pagination .el-pager li:hover {
			color: #EE632B;
		}

		.el-pagination .el-pager li:not(.disabled):hover {
			color: #EE632B;
		}

		.el-pagination .el-pager li:not(.disabled).active {

			color: #EE632B;
		}

		.el-pagination .btn-prev:hover {

			color: #EE632B;
		}

		.el-pagination .btn-next:hover {
			color: #EE632B;
		}

		li.el-select-dropdown__item.selected {
			color: #EE632B !important;
		}

		.el-input__inner:hover {
			border-color: #EE632B !important;
		}

		.el-input__inner:focus {
			border-color: #EE632B !important;
		}

	}

	/* 标题部分样式 */
	.news_title {
		height: 40px;
		width: 100%;
		margin: 20px 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-left: 10px;
		background: #F7F7F7;
	}

	.news_title_left {
		/* width: 300px; */
		height: 22px;
		
		padding-left: 20px;
		display: flex;
		justify-content: start;
		font-weight: 400;

	}

	.news_title_left div {
		margin-right: 40px;
	}

	.right_back {
		display: flex;
		font-family: PingFangSC-Regular;
		font-size: 12px;
		font-weight: normal;
		letter-spacing: 0em;
		color: #666666;
		margin-right: 10px;
	}

	.right_back:hover {
		font-weight: 800;
		color: #C9010A;
	}

	.right_back_icon {
		height: 10px;
		width: 12px;
		margin-right: 5px;
	}

	.right_back_icon img {
		height: 100%;
		width: 100%;
	}

	/* 内容部分样式 */
	.news_content {
		/* height: 754px; */
		width: 100%;
		overflow: hidden;
		margin-bottom: 20px;
		/* background-color: pink; */
	}

	.news_content_item {
		height: 122px;
		width: 100%;
		/* background-color: skyblue; */
		border-bottom: 1px solid #ECEEF4;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.news_content_item_left_time {
		height: 82px;
		width: 96px;
		/* background-color: pink; */
		border-right: 2px solid #ECEEF4;
	}

	.time_detail {
		height: 100%;
		width: 76px;

	}

	.time_detail_top {
		height: 60px;
		width: 100%;
		font-family: PingFangSC-Regular;
		font-size: 64px;
		font-weight: 400;
		line-height: 60px;
		text-align: center;
		letter-spacing: 0px;
		color: #000000;
	}

	.time_detail_bottom {
		width: 100%;
		height: 22px;
		text-align: left;
		line-height: 22px;
		font-family: PingFangSC-Regular;
		font-size: 16px;
		font-weight: normal;
		text-align: center;
		letter-spacing: 0px;
		color: #000000;
	}

	.news_content_item_right {
		height: 71px;
		width: 1102px;
		padding-left: 20px;
		/* background-color: pink; */
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.news_content_item_right_toptitle {
		height: 20px;
		width: 80%;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		font-weight: 800;
		letter-spacing: 0px;

		color: #000000;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.news_content_item_right_toptitle:hover {
		color: #C9010A;
	}

	.news_content_item_right_center {
		font-family: PingFangSC-Regular;
		font-size: 12px;
		font-weight: normal;
		line-height: 20px;
		text-align: justify;
		/* 浏览器可能不支持 */
		letter-spacing: 0px;
		color: #666666;
		height: 40px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	/* .分页器 */
	.pagination {
		height: 48px;
		width: 648px;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.pagination .block {
		margin: 0 auto;
	}

	.active_title {
		background-color: #DE483B;
	}

	.study_detail {
		width: 100%;
		height: 1200px;
		background-color: pink;
	}

	/* 视频列表 */
	.dataList {
		width: 100%;
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
		justify-content: start;
		align-content: start;
		overflow: hidden;
	}

	.dataList_item {
		box-sizing: border-box;
		width: 224px;
		height: 190px;
		margin-bottom: 20px;
		margin-right: 20px;
		/* 修改圆角 */
		border-radius: 4px;
		overflow: hidden;
	}

	.dataList_item:nth-child(5n) {
		margin-right: 0;
	}

	.dataList_item_top_img {
		height: 126px;
		width: 224px;
		/* 修改圆角 */
		border-radius: 4px 4px 0 0;
		overflow: hidden;
	}

	.dataList_item_bottom {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 100%;
		height: 64px;
		border: 1px solid #ECEEF4;
		padding: 10px;
		/* 修改圆角 */
		border-radius: 0 0 4px 4px;
		overflow: hidden;
	}

	.dataList_item_bottom_top_title {
		width: 100%;
		height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		font-weight: 800;
		line-height: 20px;
		color: #000000;
	}

	.dataList_item_bottom_top_title:hover {
		color: #C9010A;
	}

	.dataList_item_bottom_botom {
		height: 16px;
		width: 100%;
		display: flex;
	}

	.dataList_item_bottom_botom_item {
		overflow: hidden;
		height: 100%;
		width: 74px;
		display: flex;
		justify-content: center;
	}

	.dataList_item_bottom_botom_item:nth-child(2) {
		border-left: 1px solid #ECEEF4;
		border-right: 1px solid #ECEEF4;
		;
	}

	.dataList_item_bottom_botom_item:nth-child(1) {
		display: flex;
		justify-content: start;
	}

	.dataList_item_bottom_botom_item:nth-child(3) {
		display: flex;
		justify-content: end;
	}

	.dataList_item_bottom_botom_item_icon {
		height: 12px;
		width: 12px;
		margin-right: 2px;
		position: relative;
	}

	.dataList_item_bottom_botom_item_icon img {
		position: absolute;
		top: 2.5px;
	}

	.dataList_item_bottom_botom_item:nth-child(3) .dataList_item_bottom_botom_item_icon {
		height: 10px;
		width: 15px;
	}

	.dataList_item_bottom_botom_item_icon img {
		height: 100%;
		width: 100%;
	}

	.dataList_item_bottom_botom_item_content {
		font-family: PingFangSC-Regular;
		font-size: 12px;
		font-weight: normal;
		letter-spacing: 0em;

		color: #999999;
	}

}</style>
